import { changeLanguage as changei18nextLang } from 'i18next';
import { useLocation, useNavigate } from 'react-router';
import { Language } from '../constants';
import { useLanguage } from './use-language';

export const useLanguageChange = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentLanguage = useLanguage();

  const changeLanguage = async (language: Language) => {
    await changei18nextLang(language);

    const langIndex = 0;
    const locationParts = location.pathname.split('/');
    // index 0 corresponds to leading "/", therefore add 1
    locationParts[langIndex + 1] = language;
    navigate(locationParts.join('/'), { replace: true });
  };

  return {
    currentLanguage,
    changeLanguage,
  };
};
